import { render } from "./Chat.vue?vue&type=template&id=62acca7e&scoped=true&bindings={}"
import script from "./Chat.vue?vue&type=script&lang=ts"
export * from "./Chat.vue?vue&type=script&lang=ts"

import "./Chat.vue?vue&type=style&index=0&id=62acca7e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62acca7e"

export default script